import React from 'react';
import SectionHeader from './SectionHeader';
import './BrokerageChecklist.css';

const ReferralBrokerageChecklist = ({ items = [], syncStatus, isExpanded, onToggle }) => {
  if (!items.length) return null;

  const needed = items.filter((i) => i.status !== 'uploaded' && i.status !== 'on_file');
  const onFile = items.filter((i) => i.status === 'uploaded' || i.status === 'on_file');
  const requiredNeeded = needed.filter((i) => i.is_required);
  const optionalNeeded = needed.filter((i) => !i.is_required);
  const requiredOnFile = onFile.filter((i) => i.is_required);
  const requiredTotal = requiredNeeded.length + requiredOnFile.length;

  const syncLabel = () => {
    if (!syncStatus) return null;
    if (syncStatus === 'synced') return { text: '● Synced', cls: 'tms-status-synced' };
    if (syncStatus === 'failed' || syncStatus === 'error') return { text: '● Sync Error', cls: 'tms-status-error' };
    if (syncStatus === 'pending') return { text: '◌ Pending', cls: 'tms-status-pending' };
    return null;
  };
  const statusLabel = syncLabel();

  const renderGroup = (label, groupItems, variant, icon) => (
    <div className={`bc-group bc-group--${variant}`}>
      <div className="bc-group-header">
        <span className={`bc-group-label bc-group-label--${variant}`}>{label}</span>
        <span className="bc-group-count">{groupItems.length} {groupItems.length === 1 ? 'doc' : 'docs'}</span>
      </div>
      {groupItems.length === 0 ? (
        <p className="bc-group-empty">None yet</p>
      ) : (
        <div className="bc-items">
          {groupItems.map((item) => (
            <div key={item.id || item.item_name} className={`bc-item bc-item--${variant}`}>
              <span className="bc-item-icon">{icon}</span>
              <span className="bc-item-name">{item.item_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="brokerage-checklist-section">
      <div className="bc-header" onClick={onToggle}>
        <div className="bc-header-left">
          <h2 className="bc-header-title">Brokerage Document Checklist</h2>
          {statusLabel && (
            <span className={`tms-sync-status ${statusLabel.cls}`}>{statusLabel.text}</span>
          )}
        </div>
        <div className="bc-header-right">
          {requiredTotal > 0 && (
            <div className="bc-progress">
              <div className="bc-progress-bar">
                <div
                  className="bc-progress-fill"
                  style={{ width: `${Math.round((requiredOnFile.length / requiredTotal) * 100)}%` }}
                />
              </div>
              <span className="bc-progress-label">
                {requiredOnFile.length}/{requiredTotal}
              </span>
            </div>
          )}
          <button
            type="button"
            className="bc-chevron"
            onClick={(e) => { e.stopPropagation(); onToggle(); }}
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
          >
            <svg
              width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor"
              strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
              style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="bc-body">
          {requiredNeeded.length > 0 && renderGroup('Required', requiredNeeded, 'needed', '○')}
          {optionalNeeded.length > 0 && renderGroup('Optional', optionalNeeded, 'optional', '○')}
          {needed.length === 0 && (
            <p className="bc-all-clear">All required documents are on file.</p>
          )}
          {renderGroup('On File', onFile, 'on-file', '✓')}
        </div>
      )}
    </div>
  );
};

export default ReferralBrokerageChecklist;
